import React from 'react';
import bowser from 'bowser';
import Typography from '@material-ui/core/Typography';

function IeSucksBanner() {
  const isInIe = bowser.name === 'Internet Explorer';

  if (!isInIe) {
    return null;
  }

  return (
    <Typography variant="h4">
      This page is not supported in Internet Explorer. Please use another browser.
    </Typography>
  );
}

export default IeSucksBanner;
